import React from "react";

import DownArrow from "../../../styles/img/down-arrow.png";
import Select, { components } from "react-select";
import PropTypes from "prop-types";
import UiTopInputElementsWr from "./UiTopInputElementsWr";

export default function UiTopSelect(props) {
    const colourOptions = [
        { value: "earn", label: "January" },
        { value: "rewards", label: "February" },
    ];
    const DropdownIndicator = (props) => {
        return (
            <components.DropdownIndicator {...props}>
                <img src={DownArrow} />
            </components.DropdownIndicator>
        );
    };
    const colorStyles = {
        placeholder: (defaultStyles) => {
            return {
                ...defaultStyles,
                color: "#B1B5C3",
            };
        },
    };

    return (
        <>
            <UiTopInputElementsWr>
                {props.label && (
                    <>
                        <label htmlFor={props.label}>{props.label}</label>
                    </>
                )}
                <Select
                    className="basic-single"
                    classNamePrefix="select"
                    components={{ DropdownIndicator }}
                    styles={colorStyles}
                    placeholder={props.placeholder}
                    options={props.selectOptions}
                />
            </UiTopInputElementsWr>
        </>
    );
}

UiTopSelect.propTypes = {
    label: PropTypes.string,
};
